// removed by extract-text-webpack-plugin
module.exports = {"image":"StaticImage__image__3ehs6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexPage/StaticImage.scss
// module id = 673
// module chunks = 0